import {
  StandardGamepadAxisIndex,
  StandardGamepadButtonIndex,
  VPadStage,
} from '@/interfaces/virtualPad_types'

export enum VPadP2PActionType {
  BUTTON = 'button',
  MOVEMENT = 'movement',
  CLOSE = 'close',
  PING = 'ping',
  STATUS = 'status'
}

export type VPadP2PAction =
  | VPadP2PButtonAction
  | VPadP2PMovementAction
  | VPadP2PCloseAction
  | VPadP2PPingAction
  | VPadP2PStatusAction

export interface VPadP2PButtonAction {
  type: VPadP2PActionType.BUTTON
  buttonIndex: StandardGamepadButtonIndex
  value: number
}

export interface VPadP2PAxisUpdate {
  index: StandardGamepadAxisIndex
  value: number
}

export interface VPadP2PMovementAction {
  type: VPadP2PActionType.MOVEMENT
  axes: [
    horizontal: VPadP2PAxisUpdate,
    vertical: VPadP2PAxisUpdate,
  ]
}

export interface VPadP2PCloseAction {
  type: VPadP2PActionType.CLOSE
}

export interface VPadP2PPingAction {
  type: VPadP2PActionType.PING
  sentAt: string
}

export interface VPadP2PStatusAction {
  type: VPadP2PActionType.STATUS
  status: VPadStage
}